<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Operator Match Report'"></cardHead>

      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-10"
        ref="form"
      >
        <formGroup
          :title="'CountryId'"
          :as="'select'"
          :disabled="countries.length == 0"
          v-model="countryId"
          :errors="errors"
          @change="get"
        >
          <template #input>
            <option v-for="item in countries" :value="item.Id" :key="item.Id">{{
              item.Name
            }}</option>
          </template>
        </formGroup>
      </Form>
      <dataTable
        :name="'TourScopeOperatorMatchReport'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @update="updateShow = $event"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || (updateShow != null && data != null)"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        :operators="data"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
export default {
  name: "OperatorMatchReport",
  components: { upsert },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
      countries: [],
      countryId: 228,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 70,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "MainOperatorId",
          field: "MainOperatorId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 160,
        },
        {
          headerName: "HotelCount",
          field: "HotelCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "MatchedHotelCount",
          field: "MatchedHotelCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 180,
        },
        {
          headerName: "DepartureCityCount",
          field: "DepartureCityCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 180,
        },
        {
          headerName: "MatchedDepartureCityCount",
          field: "MatchedDepartureCityCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 240,
        },
        {
          headerName: "DestinationCountryCount",
          field: "DestinationCountryCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 220,
        },
        {
          headerName: "UsingSameHotelsWithMainOperator",
          field: "UsingSameHotelsWithMainOperator",
          enableRowGroup: true,
          floatingFilter: true,
          filter: false,
          flex: 1,
          cellClick: true,
          minWidth: 280,
          cellRenderer: this.$CheckCellRenderer,
        },
      ],
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`TOURSCOPE/Reports/OperatorMatchReport/` + this.countryId)
        .then((response) => {
          this.data = response.data;
        });
    },
  },
};
</script>
